import styled, { css } from 'styled-components/macro'

import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  height: var(--header-height);
  color: ${theme.colors.accent.secondary};
  z-index: 50;

  ${mq.smallOnly} {
    display: flex;
    align-items: center;
  }
`

export const Year = styled.span`
  display: block;
  padding: 0.3em 1rem 0.1em 0;
  border-right: 1px solid ${theme.colors.accent.secondary};
  font-size: 3rem;
  font-weight: 800;
  line-height: 1;
  color: ${theme.colors.accent.primary};

  ${mq.smallOnly} {
    display: none;
  }
`

export const PlayButton = styled.button<{ $isMute?: boolean }>`
  ${styleReset}
  font-size: 2.4rem;
  padding: 1rem;
  cursor: pointer;

  ${props =>
    props.$isMute &&
    css`
      ${mq.smallOnly} {
        order: 1;
      }
    `}

  svg {
    display: block;
  }
`

export const Time = styled.div`
  padding-top: 0.2em;
  font-size: 1.8rem;

  ${mq.smallOnly} {
    font-size: 1.4rem;
    width: max-content;
    margin-left: 1rem;
    order: 1;
  }
`

const trackStyles = css`
  width: 100%;
  height: 3px;
  cursor: pointer;
  box-shadow: none;
  border-radius: 4px;
  background: ${theme.colors.accent.secondary}55;
  border: none;
`

const thumbStyles = css`
  box-shadow: none;
  border: none;
  height: 16px;
  width: 16px;
  border-radius: 8px;
  background: ${theme.colors.accent.primary};
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -6px;
`

export const Slider = styled.input.attrs({ type: 'range' })`
  width: 5rem;
  margin: 0 1rem;

  ${mq.smallOnly} {
    margin: 0;
    width: 7rem;
  }

  ${mq.medium} {
    width: 10rem;
  }

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    height: 4px;
  }

  &::-webkit-slider-thumb {
    ${thumbStyles}
  }

  &::-moz-range-track {
    ${trackStyles}
    background: ${theme.colors.accent.secondary};
  }

  &::-moz-range-progress {
    ${trackStyles}
    background: ${theme.colors.accent.primary};
  }

  &::-moz-range-thumb {
    ${thumbStyles}
  }

  &:disabled::-moz-range-thumb {
    cursor: not-allowed;
    background: #aaa;
  }

  &:disabled::-moz-range-track {
    cursor: not-allowed;
    background: #ddd;
  }

  &::-ms-track {
    ${trackStyles}
  }

  &::-ms-fill-lower {
    ${trackStyles}
    background-color: ${theme.colors.accent.secondary};
  }

  &::-ms-fill-upper {
    ${trackStyles}
  }

  &::-ms-thumb {
    ${thumbStyles}
  }
`

export const CounterContainer = styled.span<{
  isEmpty: boolean
  disabled: boolean
}>`
  transition: color 0.3s;

  ${props =>
    props.isEmpty &&
    css`
      visibility: hidden;
    `}

  ${props =>
    props.disabled &&
    css`
      color: #ccc;
    `}
`

export const TotalLength = styled.span`
  ${mq.extraSmall} {
    display: none;
  }
`
